import { catchError, EMPTY, Observable } from 'rxjs';
import type ZenObservable from 'zen-observable';

import { log } from '@libs/utils';

let subscription = 0;

export function logged<T>(name: string) {
  return (source: Observable<T>): Observable<T> => {
    const prefix = `${name} ${subscription}`;
    subscription++;

    log(prefix, 'subscribed');
    return new Observable<T>((subscriber) => {
      let completed = false;

      const subscription = source.subscribe(
        (x) => {
          log(prefix, 'new item', x);
          subscriber.next(x);
        },
        (ex) => {
          log(prefix, 'error', ex);
          completed = true;
          subscriber.error(ex);
        },
        () => {
          log(prefix, 'completed');
          completed = true;
          subscriber.complete();
        }
      );

      return () => {
        if (!completed) {
          log(prefix, 'cancelled');
        }

        log(prefix, 'disposed');
        subscription.unsubscribe();
      };
    });
  };
}

export function zenToRx<T>(zenObservable: ZenObservable<T>): Observable<T> {
  return new Observable<T>((subscriber) =>
    zenObservable.subscribe(subscriber)
  ).pipe(
    catchError((x) => {
      log('zenToRx Error', x);
      return EMPTY;
    })
  );
}
